import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '../pages/SignIn';
// import SignUp from '../pages/SignUp';
// import ForgotPassword from '../pages/ForgotPassword';
// import ResetPassword from '../pages/ResetPassword';

import Home from '../pages/Home';
// import Agenda from '../pages/Agenda';
// import Profile from '../pages/Profile';
// import LeftSideBar from '../pages/LeftSideBar';

import NaoEncontrada from '../pages/NaoEncontrada';

const Routes: React.FC = () => {

  return (
    <>
      <Switch>

        <Route path="/home/:id" component={Home} isPrivate />
        <Route path="/home" component={Home} isPrivate />

        <Route path="/nao-encontrada" exact component={NaoEncontrada} />

        <Route path="/:empresa" exact component={SignIn} />

        <Route component={NaoEncontrada} />
      </Switch>
    </>
  )
};

export default Routes;
